"use client"

import { createRoute } from "@tanstack/react-router"

import { rootRoute } from "@/App"
import { LogoLockup } from "@/components/auth/graphite-sign-in"
import { PageAction } from "@/components/graphite/page-header"
import { useAuth } from "@/hooks/useAuth"

const REQUEST_ACCESS_HREF =
  "mailto:herimino@thedevfactory.ca?subject=RecruiterOS%20access%20request"

/**
 * Where a signed-in user with no organization lands. Access is by invitation,
 * so there is nothing to do in the app yet: ask for access, or sign in with the
 * account that was invited. Public (under rootRoute, like sign-in) because the
 * backend answers `/auth/user` with 403 for these users.
 */
const NoAccessPage = createRoute({
  getParentRoute: () => rootRoute,
  path: "/no-access",
  component: NoAccess,
})
export default NoAccessPage

function NoAccess() {
  const { logout } = useAuth()

  return (
    <div className="graphite-auth flex min-h-screen flex-col bg-background px-6 py-[30px] text-foreground">
      <LogoLockup />

      <div className="flex flex-1 items-center justify-center">
        <div className="flex w-full max-w-[372px] flex-col gap-[22px]">
          <div className="flex flex-col gap-[7px]">
            <h1 className="text-[26px] font-semibold leading-[1.15] tracking-[-0.025em]">
              You don't have access yet
            </h1>
            <p className="text-[13px] leading-[1.6] text-muted-foreground">
              RecruiterOS is invitation-only, and this account isn't part of an
              organization. Ask for access, or sign in with the account your admin
              invited.
            </p>
          </div>

          <div className="flex items-center gap-4">
            <a
              href={REQUEST_ACCESS_HREF}
              className="inline-flex h-9 items-center rounded-md bg-primary px-[15px] text-[12.5px] font-medium text-primary-foreground transition-opacity hover:opacity-90"
            >
              Request access
            </a>
            {/* This route has no guards, so reloading it never re-checks access.
                A full load of the app re-runs both route gates with an empty
                cache, so a user granted access meanwhile gets straight in. */}
            <PageAction tone="teal" onClick={() => window.location.assign("/dashboard")}>
              Check again
            </PageAction>
            <PageAction onClick={() => void logout()}>Use a different account</PageAction>
          </div>
        </div>
      </div>
    </div>
  )
}
